

export default function header() {
    return <div>

        <nav className="navbar navbar-expand-lg navbar-dark text-white  ">
            <a href="/" className="navbar-brand">PMPaws<img className="pawp" src="images/pawpalz.png" alt="" /></a>
            {/* <!-- togglar is used to watch the movement of the nav bar and when it get to 
                       smaller screen t creste an handburger which when it is clicked it will show all the itemes on the narvbar  --> */}
              <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
            <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item">
                        <a className=" text-white nav-link" href='/boarding' > Boarding</a>
                    </li>
                    <li className="nav-item">
                        <a className=" text-white nav-link" href="/daycare"    >
                            Daycare/Spa</a>
                    </li>

                    <li className="nav-item">
                        <a className="  text-white nav-link" href="/aboutus"   > About Us</a>
                    </li>

                    <li className="nav-item">

                        <a className=" text-white nav-link" href="/contactus"  > Contact</a>
                    </li>


                </ul>
            </div>
        </nav>
    </div>;
}
